import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import * as XLSX from "xlsx";

import promotionApi from "../../../apis/Promotion.api";
import ReturnApi from "../../../apis/Return.api";
import salesManageApi from "../../../apis/SalesManage.api";
import {
  setLoading,
  setRecordDates,
  setSearchText,
} from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import OrderDetailComponent from "./OrderDetailComponent";

const ReturnManage = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const searchText = useSelector((state) => state.common.searchText);
  const setIsSearchText = (value) => dispatch(setSearchText(value));
  const recordDates = useSelector((state) => state.common.recordDates);
  const setDates = (value) => dispatch(setRecordDates(value));
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [mediaResult, setMediaResult] = useState(null);
  const [collectionFailHover, setCollectionFailHover] = useState(false);
  const [returnDelayHover, setReturnDelayHover] = useState(false);
  const [refundDelayHover, setRefundDelayHover] = useState(false);
  const [returnRequestHover, setReturnRequestHover] = useState(false);
  const [returnDeliveryHover, setReturnDeliveryHover] = useState(false);
  const [returnDeliveryCompleteHover, setReturnDeliveryCompleteHover] =
    useState(false);
  const [returnCompleteHover, setReturnCompleteHover] = useState(false);
  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    searchType: "return_request_at",
    searchStatus: "return_request",
    searchDetailType: "",
    searchDetail: "",
    searchOrderId: "",
    searchProductName: "",
    funnel: 0,
    name: "",
    phone: "",
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
  });
  const [orderType, setOrderType] = useState("return_request_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [deliveryCompanyList, setDeliveryCompanyList] = useState([]);
  const [totalOrderList, setTotalOrderList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [orderDetail, setOrderDetail] = useState({});
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [error, setError] = useState("");

  const [receiveModalOpen, setReceiveModalOpen] = useState(false);
  const [isEditForShipmentPlace, setIsEditForShipmentPlace] = useState(false);
  const [isTrackNumberShow, setIsTrackNumberShow] = useState(false);
  const [trackNumber, setTrackNumber] = useState({
    delivery_company: null,
    tracking_number: "",
    shipment_place: "",
    collection_date:
      moment().add(3, "days").day() === 0
        ? moment().add(4, "days")
        : moment().add(3, "days"),
  });
  // 반품 철회시 거부 사유 입력
  const [returnRefusalModalOpen, setReturnRefusalModalOpen] = useState(false);
  const [refusalReason, setRefusalReason] = useState(null);
  const [costSettingModalOpen, setCostSettingModalOpen] = useState(false);
  const [costInfo, setCostInfo] = useState({
    possible_amount: 0,
    additional_cost: 0,
    reason: null,
  });
  // 반품완료처리 및 환불안내 팝업
  const [returnCompleteModalOpen, setReturnCompleteModalOpen] = useState(false);
  const [refundInfo, setRefundInfo] = useState({
    cal_history: "",
    total: 0,
  });

  const searchDateItems = [
    { searchText: "반품요청일", searchType: "return_request_at" },
    { searchText: "수거완료일", searchType: "return_collection_completed_at" },
    { searchText: "배송완료일", searchType: "return_delivery_completed_at" },
    { searchText: "결제일", searchType: "payment_created_at" },
  ];
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
  ];
  const orderStatusItems = [
    { label: "전체", value: "total" },
    { label: "반품요청", value: "return_request" },
    { label: "반품승인", value: "return_receive" },
    { label: "반품수거완료", value: "return_collection_complete" },
    { label: "반품배송중", value: "return_delivery" },
    { label: "반품배송완료", value: "return_delivery_complete" },
    { label: "반품완료", value: "return_complete" },
    { label: "반품수거취소", value: "return_collection_fail" },
    { label: "반품거부/철회", value: "return_refusal" },
  ];
  const funnelStatusItems = [
    { label: "전체", value: 0 },
    { label: "검색", value: 1 },
    { label: "전화주문", value: 4 },
    { label: "인플루언서", value: 2 },
    { label: "셀러", value: 5 },
    { label: "공동구매", value: 3 },
  ];
  const orderPair = {
    payment_created_at: "결제일순",
    order_id: "주문번호순",
    // ship_date: '발송일순',
    created_at: "주문일시순",
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
      setSelectedRow(selectedRows);
    },
  };
  const columns = [
    {
      title: "주문번호",
      width: 80,
      dataIndex: "order_id",
      key: "order_id",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      align: "center",
      // sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className="recommend-inquiry-list-title"
            onClick={() => {
              setOrderDetail(record);
              setIsOrderModalOpen(true);
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "상품주문번호",
      width: 90,
      dataIndex: "order_detail_id",
      key: "order_detail_id",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      align: "center",
      // sorter: (a, b) => {},
      // render: (value, record) => {
      //     return <span
      //         className="recommend-inquiry-list-title"
      //         onClick={() => {
      //             setOrderDetail(record)
      //             setIsOrderModalOpen(true)
      //         }}
      //     >{value}</span>
      // }
    },
    {
      title: "처리상태",
      width: 100,
      dataIndex: "order_detail_status",
      key: "order_detail_status",
      ellipsis: true,
      align: "center",
      // sorter: (a, b) => {
      // },
      render: (value) => {
        if (value !== null) {
          return status.orderStatusChange(value);
        }
      },
    },
    {
      title: "반품요청일",
      width: 160,
      dataIndex: "cancel_request_date",
      key: "cancel_request_date",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "상품명",
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
      render: (value, record) => {
        return `[${record.product_brand_name}] ${value} ${
          record.option_id ? " - " + record.option_title : ""
        }`;
      },
    },
    {
      title: "반품사유",
      width: 200,
      dataIndex: "cancel_reason",
      key: "cancel_reason",
      ellipsis: true,
      align: "center",
      render: (value, record) => {
        if (record.cancel_reason_detail) {
          return value + " - " + record.cancel_reason_detail;
        } else {
          return value;
        }
      },
    },
    {
      title: "반품승인일",
      width: 160,
      dataIndex: "cancel_approval_date",
      key: "cancel_approval_date",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "택배사",
      dataIndex: "return_delivery_company",
      key: "return_delivery_company",
      align: "center",
      render: (value) => {
        if (value === null || value === "") {
          return value;
        } else {
          const findDeliveryCompany = deliveryCompanyList.find(
            (deliveryCompany) => deliveryCompany.delivery_company_id === value,
          );
          if (findDeliveryCompany) {
            return findDeliveryCompany.delivery_company_name;
          } else {
            return value;
          }
        }
      },
    },
    {
      title: "반송장번호",
      width: 100,
      dataIndex: "return_tracking_number",
      key: "return_tracking_number",
      ellipsis: true,
      align: "center",
      render: (value, record) => {
        if (value) {
          return (
            <a onClick={(e) => deliveryPopup(e, record)} href={`#`}>
              {value}
            </a>
          );
        }
      },
    },
    {
      title: "반품수거완료일",
      width: 160,
      dataIndex: "return_collection_complete_date",
      key: "return_collection_complete_date",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "반품배송완료일",
      width: 160,
      dataIndex: "return_delivery_complete_date",
      key: "return_delivery_complete_date",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "반품완료일",
      width: 160,
      dataIndex: "return_complete_date",
      key: "return_complete_date",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "결제일",
      width: 160,
      dataIndex: "payment_created_at",
      key: "payment_created_at",
      ellipsis: true,
      align: "center",
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
  ];
  const columnsForRefusal = [
    {
      title: "주문번호",
      width: 80,
      dataIndex: "order_id",
      key: "order_id",
      fixed: mediaResult ? "" : "left",
      // ellipsis: true,
      align: "center",
      // sorter: (a, b) => {},
      // render: (value, record) => {
      //     return <span
      //         className="recommend-inquiry-list-title"
      //         onClick={() => {
      //             setOrderDetail(record)
      //             setIsOrderModalOpen(true)
      //         }}
      //     >{value}</span>
      // }
    },
    {
      title: "상품주문번호",
      width: 90,
      dataIndex: "order_detail_id",
      key: "order_detail_id",
      fixed: mediaResult ? "" : "left",
      // ellipsis: true,
      align: "center",
      // sorter: (a, b) => {},
    },
    {
      title: "상품명",
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
      render: (value, record) => {
        return `[${record.product_brand_name}] ${value} ${
          record.option_id ? " - " + record.option_title : ""
        }`;
      },
    },
    {
      title: "상품별 구매가",
      dataIndex: "total_price",
      key: "total_price",
      // ellipsis: true,
      align: "center",
      render: (value) => {
        if (value) {
          return value.toLocaleString() + "원";
        }
      },
    },
  ];

  /**
   * 쿼리로 상태값 관리하기
   */
  const [propsType, setPropsType] = useState(false);
  // const [oneTime, setOneTime] = useState(false);

  useEffect(() => {
    let type = props.location.search?.split("?type=")[1];
    if (!propsType && type) {
      setIsSearchText(type);
      setDates({
        startDate: moment().subtract(7, "days").startOf("day"),
        endDate: moment().endOf("day"),
      });
      setPropsType(true);
      // setIsLoading(true);
      // if (type) {
      // 	setSearchOptions({
      // 		...searchOptions,
      // 		startDate: moment().subtract(14, "d"),
      // 		searchStatus: type,
      // 	});
      // 	setPropsType(true);
      // 	// getUserOrderListType(type);
      // } else {
      // 	getDeliveryCompanyList();
      // 	getUserOrderList("initial");
      // 	getReturnSummary();
      // 	setPropsType(true);
      // }
    }
  }, [props, propsType]);
  //
  // useEffect(() => {
  // 	let type = props.location.search?.split("?type=")[1];
  // 	if (type) {
  // 		if (!oneTime) {
  // 			const timer = setTimeout(() => {
  // 				getUserOrderList();
  // 				setOneTime(true);
  // 			}, 200);
  // 			return () => clearTimeout(timer);
  // 		}
  // 	}
  // }, [props, searchOptions, oneTime]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const matchQueryList = window.matchMedia("all and (max-width: 768px)");
      setMediaResult(matchQueryList.matches);
      // if (!matchQueryList.matches) {
      //     setMobileColumn(false);
      // }

      const media = function handleChange(e) {
        setMediaResult(e.matches);
        // if (!e.matches) {
        //     setMobileColumn(false);
        // }
      };

      matchQueryList.addEventListener("change", media);
    }
    getDeliveryCompanyList();
    getReturnSummary();
    getUserOrderList("initial");
  }, []);

  useEffect(() => {
    if (searchText && searchText !== " ") {
      setDateType("");
      setSearchOptions({
        ...searchOptions,
        startDate: recordDates.startDate,
        endDate: recordDates.endDate,
        searchStatus:
          searchText === "return_delay"
            ? "return_delivery_complete"
            : searchText === "return_refund_delay"
            ? "return_complete"
            : searchText,
      });
      getUserOrderList(
        "custom",
        recordDates.startDate,
        recordDates.endDate,
        searchText,
      );
    }
  }, [searchText]);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize));
  }, [offset, pageSize]);

  useEffect(() => {
    handleChangePagination(currentPageNumber);
  }, [pageSize]);

  useEffect(() => {
    if (searchText && searchText !== " ") {
      getUserOrderList(
        "custom",
        recordDates.startDate,
        recordDates.endDate,
        searchText,
      );
    } else {
      getUserOrderList();
    }
  }, [orderType, orderBy]);

  const [returnStatus, setReturnStatus] = useState({
    returnRequest: 0,
    returnDelivery: 0,
    returnDeliveryComplete: 0,
    returnComplete: 0,
    returnCollectionFail: 0,
    returnDelay: 0,
    returnRefundDelay: 0,
  });

  /**
   * 반품관리 상태값 개수 가져오기
   * @returns {Promise<void>}
   */
  const getReturnSummary = async () => {
    let param = {
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await salesManageApi.salesManageStatus(param);
    if (res.code === 200) {
      setReturnStatus({
        returnRequest: res.result.returnRequestList,
        returnDelivery: res.result.returnDeliveryList,
        returnDeliveryComplete: res.result.returnDeliveryCompleteList,
        returnComplete: res.result.returnCompleteList,
        returnCollectionFail: res.result.returnCollectionFailList,
        returnDelay: res.result.returnDelayList,
        returnRefundDelay: res.result.returnRefundDelayList,
      });
    }
  };

  const getDeliveryCompanyList = async () => {
    setIsLoading(true);
    try {
      const res = await salesManageApi.deliveryCompanyList("delivery_tracker");
      if (res.code === 200) {
        setDeliveryCompanyList(res.result);
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getDeliveryCompanyList read error", error);
    }
  };

  const getUserOrderList = async (
    type = "",
    startDate,
    endDate,
    searchStatus,
  ) => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "return",
          searchDateItems[0].searchType,
          moment().subtract(7, "days").startOf("day").format("YYYYMMDDHHmm"),
          moment().endOf("day").format("YYYYMMDDHHmm"),
          orderStatusItems[1].value,
          "",
          "",
          0,
          "",
          "",
          "payment_created_at",
          "desc",
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "search") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "return",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "custom") {
        res = await salesManageApi.searchOrderDetailList(
          offset,
          pageSize,
          "return",
          searchOptions.searchType,
          startDate.startOf("day").format("YYYYMMDDHHmm"),
          endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await salesManageApi.searchOrderDetailList(
          offset,
          pageSize,
          "return",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        // if (res.result.userOrderDetailDTOList?.length > 1) {
        // 	if (orderType === "created_at") {
        // 		if (orderBy === "desc") {
        // 			res.result.userOrderDetailDTOList.sort(
        // 				(a, b) => moment(b.created_at) - moment(a.created_at)
        // 			);
        // 		} else {
        // 			res.result.userOrderDetailDTOList.sort(
        // 				(a, b) => moment(a.created_at) - moment(b.created_at)
        // 			);
        // 		}
        // 	}
        // }
        setTotalOrderList(res.result.userOrderDetailDTOList);
        if (type === "initial" || type === "search") {
          setOrderList(res.result.userOrderDetailDTOList.slice(0, 10));
        } else {
          setOrderList(
            res.result.userOrderDetailDTOList.slice(offset, offset + pageSize),
          );
        }
        if (res.result?.length !== 0) {
          setTotalSize(res.result.totalCnt);
        } else {
          setTotalSize(0);
        }
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getUserOrderList read error", error);
    }
  };

  /**
   * 선택한 주문의 반품 관련 주문 목록 정보 조회 (2023.07.21) - ksb
   * 1. 선택한 주문이외의 반품 관련 주문 목록들의 기타 반품비용 합계
   */
  const getOrderDetailListInfoForReturn = async () => {
    setIsLoading(true);
    try {
      const param = {
        orderId: selectedRow[0].order_id,
        orderDetailId: selectedRow[0].order_detail_id,
        userId: user.id === 724 ? 1 : user.id,
      };
      const res = await ReturnApi.getEtcReturnPriceSum(param);
      if (res.code === 200) {
        let availablePrice =
          selectedRow[0].payment_total_price - res.result.etc_return_price;
        // 반품배송비 환불금에서 차감이면 해당 금액만큼 제외
        if (
          selectedRow[0].return_responsibility === 0 &&
          !selectedRow[0].purchase_return_price
        ) {
          availablePrice -=
            selectedRow[0].return_delivery_price -
            selectedRow[0].paid_total_delivery_price;
        }
        setCostInfo({ ...costInfo, possible_amount: availablePrice });
        setIsLoading(false);
      } else if (res.code === 999) {
        throw res.msg;
      } else {
        throw "반품가능한 비용을 계산하기 위해 조회하는 부분에서 오류가 발생했습니다. 다시 시도해주시거나 똑같은 오류가 계속해서 발생한다면 관리자에게 문의해주시길 바랍니다.";
      }
    } catch (e) {
      setCostInfo({ ...costInfo, possible_amount: null });
      setIsLoading(false);
      setError(error);
      console.log("getOrderDetailListInfoForReturn read error", error);
    }
  };

  const changeOrderStatus = async (orderStatus) => {
    setIsLoading(true);
    try {
      const orderIdSet = new Set(
        selectedRow.map((selectedRow) => selectedRow.order_id),
      );
      const editOrderList = {
        orderIdList: [...orderIdSet],
        orderDetailIdList: selectedRowKey,
        order_status: orderStatus,
        updated_by: user.id === 724 ? 1 : user.id,
      };
      if (orderStatus === "return_refusal") {
        editOrderList["cancel_refusal_reason"] = refusalReason.trim();
      } else if (orderStatus === "return_receive") {
        if (isEditForShipmentPlace) {
          const orderDetailList = selectedRow.map((row) => {
            return { ...row, shipment_place: trackNumber.shipment_place };
          });
          editOrderList["shipment_place"] = trackNumber.shipment_place;
          editOrderList["orderDetailWithProductList"] = orderDetailList;
        } else {
          editOrderList["orderDetailWithProductList"] = selectedRow;
        }
        editOrderList["return_collection_expected_date"] =
          trackNumber.collection_date;
        editOrderList["return_delivery_company"] = trackNumber.delivery_company;
      }
      const res = await salesManageApi.orderStatusEdit(editOrderList);
      if (res.code === 200) {
        if (orderStatus === "return_refusal") {
          alert(
            `총 ${selectedRow?.length}건의 반품거부 처리가 완료되었습니다. 자동수거지시 처리된 주문건의 경우 택배사로 직접 수거취소 진행해 주세요.`,
          );
          handleReturnRefusalModalCancel();
        } else if (orderStatus === "return_receive") {
          alert(
            `총 ${selectedRow?.length}건의 반품승인 처리가 완료되었습니다.`,
          );
          handleReceiveModalCancel();
        } else if (orderStatus === "return_complete") {
          alert(
            `총 ${selectedRow?.length}건의 반품완료 처리가 완료되었습니다.`,
          );
          if (returnCompleteModalOpen) {
            handleReturnCompleteModalCancel();
          }
        } else {
          alert("해당 내용이 성공적으로 반영되었습니다.");
        }
        setSelectedRowKey([]);
        setSelectedRow([]);
        getUserOrderList();
        getReturnSummary();
      } else if (res.code === 999 || res.code === 405) {
        alert(res.msg);
        setIsLoading(false);
      } else {
        alert(
          "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.",
        );
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("changeOrderStatus edit error", error);
    }
  };

  /**
   * 반품 완료처리 버튼 클릭
   */
  const handleReturnCompleteClick = async () => {
    setIsLoading(true);
    try {
      // 1. 선택한 주문번호에 대한 detail목록 조회
      const param = {
        order_id: selectedRow[0].order_id,
        user_id: selectedRow[0].created_by,
        exceptedOrderDetailIdList: selectedRowKey.join(","),
      };
      const res = await salesManageApi.searchOrderOne(param);
      if (res.code === 200) {
        setIsLoading(false);
        if (
          res.result.orderDetailDTOList?.length === 0 ||
          res.result.orderDetailDTOList.every(
            (orderDetail) =>
              orderDetail.order_detail_status === "return_complete",
          )
        ) {
          // 2-1. 전체 반품 완료 및 환불처리 진행 -> 환불 안내 팝업 열기
          let sum = selectedRow[0].payment_total_price;
          let sumStr = `${selectedRow[0].payment_total_price.toLocaleString()}원`;
          if (
            selectedRow[0].return_responsibility === 0 &&
            !selectedRow[0].purchase_return_price
          ) {
            sum -=
              selectedRow[0].return_delivery_price -
              selectedRow[0].paid_total_delivery_price;
            sumStr += ` - ${(
              selectedRow[0].return_delivery_price -
              selectedRow[0].paid_total_delivery_price
            ).toLocaleString()}원`;
          }
          for (let i = 0; i < selectedRow?.length; i++) {
            const row = selectedRow[i];
            if (row.etc_return_price) {
              sum -= selectedRow[0].etc_return_price;
              sumStr += ` - ${selectedRow[0].etc_return_price.toLocaleString()}원`;
            }
          }
          sumStr += ` = ${sum.toLocaleString()}원`;
          if (sumStr.split(" = ")[0] === sumStr.split(" = ")[1]) {
            sumStr = "";
          }
          setRefundInfo({
            cal_history: sumStr,
            total: sum,
          });
          setReturnCompleteModalOpen(true);
        } else {
          // 2-2. 반품 완료 처리
          if (
            window.confirm(
              `총 ${selectedRow?.length}건 반품 완료 처리 진행하시겠습니까?\n\n* 같은 주문번호 내 반품완료처리되지 않은 건이 존재합니다. 해당건까지 반품 완료되어야만 환불처리가 진행됩니다.`,
            )
          ) {
            changeOrderStatus("return_complete");
            // setReturnCompleteModalOpen(true);
          }
        }
      } else {
        throw "서버오류가 발생했습니다. 새로고침 후 다시 시도해주시길 바랍니다.";
      }
    } catch (e) {
      setIsLoading(false);
      alert(e);
    }
  };

  /**
   * 반품 송장 저장
   */
  const handleTrackNumber = async () => {
    try {
      if (trackNumber.tracking_number?.trim() && trackNumber.delivery_company) {
        setIsLoading(true);
        let hasTrackingNum = false;
        const findCompanyIdx = deliveryCompanyList.findIndex(
          (delivery) =>
            delivery.delivery_company_id === trackNumber.delivery_company,
        );
        if (findCompanyIdx === -1) {
          throw "데이터를 저장하는 부분에서 오류가 발생했습니다. 다시 시도해주세요.\n만약 동일한 오류가 계속해서 발생한다면, 관리자에게 문의해주시길 바랍니다.";
        }
        for (let i = 0; i < selectedRow?.length; i++) {
          const row = selectedRow[i];
          if (row.return_tracking_number) {
            hasTrackingNum = true;
            break;
          }
        }
        let alertStr = `총 ${selectedRow?.length}건에 ${deliveryCompanyList[findCompanyIdx].delivery_company_name} - ${trackNumber.tracking_number}를 등록하시겠습니까?`;
        if (hasTrackingNum) {
          alertStr =
            `선택된 주문들 중 이미 반품 송장번호가 등록된 주문건이 존재합니다. 해당 주문건 포함해서 ` +
            alertStr;
        }
        if (window.confirm(alertStr)) {
          let paramDetailList = [];
          for (let i = 0; i < selectedRow?.length; i++) {
            const row = selectedRow[i];
            const orderDetailItem = {
              order_id: row.order_id,
              order_detail_id: row.order_detail_id,
              product_brand_id: row.product_brand_id,
              product_brand_name: row.product_brand_name,
              product_id: row.product_id,
              product_name: row.product_name,
              option_id: row.option_id ?? null,
              option_title: row.option_title,
              order_detail_status: row.order_detail_status,
              delivery_company: trackNumber.delivery_company,
              tracking_number: trackNumber.tracking_number,
              created_by: row.created_by,
            };
            paramDetailList.push(orderDetailItem);
          }
          const param = {
            userOrderDetailDTOList: paramDetailList,
            updated_by: user.id === 724 ? 1 : user.id,
          };
          const res = await ReturnApi.postTrackingNumber(param);
          if (res.code === 200) {
            alert("작성하신 반품 송장 정보를 성공적으로 등록하였습니다.");
            handleRegisterTrackingModalCancel();
            setSelectedRow([]);
            setSelectedRowKey([]);
            getUserOrderList();
          } else {
            handleRegisterTrackingModalCancel();
            setSelectedRow([]);
            setSelectedRowKey([]);
            getUserOrderList();
            throw res.msg.replaceAll("return_", "");
          }
        }
        setIsLoading(false);
      } else {
        throw "택배사 또는 송장번호를 올바르게 입력해주세요.";
      }
    } catch (e) {
      setIsLoading(false);
      alert(e);
    }
  };

  /**
   * 반품 승인처리 팝업 내 확인 버튼 클릭
   */
  const returnReceive = async () => {
    if (trackNumber.collection_date && trackNumber.delivery_company) {
      setIsLoading(true);
      const findCompanyIdx = deliveryCompanyList.findIndex(
        (delivery) =>
          delivery.delivery_company_id === trackNumber.delivery_company,
      );
      if (findCompanyIdx === -1) {
        alert(
          "데이터를 저장하는 부분에서 오류가 발생했습니다. 다시 시도해주세요.\n만약 동일한 오류가 계속해서 발생한다면, 관리자에게 문의해주시길 바랍니다.",
        );
        setIsLoading(false);
      } else {
        if (
          window.confirm(
            `수거 택배사: ${
              deliveryCompanyList[findCompanyIdx].delivery_company_name
            }\n수거 예정일: ${trackNumber.collection_date.format(
              "YYYY-MM-DD",
            )}\n수거지: ${
              isEditForShipmentPlace
                ? trackNumber.shipment_place
                : "각 상품별 반품/교환 회수지"
            }\n위의 정보로 고객분께 안내될 예정입니다. 총 ${
              selectedRow?.length
            }건 반품 승인 처리 진행하시겠습니까?`,
          )
        ) {
          changeOrderStatus("return_receive");
        } else {
          setIsLoading(false);
        }
      }
    } else {
      alert("택배사 또는 송장번호를 올바르게 입력해주세요.");
    }
  };

  /**
   * 반품 거부(철회) 처리 팝업 내 확인 버튼 클릭
   */
  const returnRefusal = async () => {
    if (
      window.confirm(
        `거부 사유: ${refusalReason}\n총 ${selectedRow?.length}건 반품 거부 처리 진행하시겠습니까?`,
      )
    ) {
      await changeOrderStatus("return_refusal");
    }
  };

  /**
   * 반품비용 설정 팝업 내 저장 버튼 클릭
   */
  const registerEtcReturnPrice = async () => {
    if (
      window.confirm(
        `"${
          costInfo.reason
        }"로 반품 비용 ${costInfo.additional_cost.toLocaleString()}원 청구 진행하시겠습니까?`,
      )
    ) {
      setIsLoading(true);
      try {
        const param = {
          ...selectedRow[0],
          etc_return_price: costInfo.additional_cost,
          etc_return_price_reason: costInfo.reason.trim(),
          updated_by: user.id === 724 ? 1 : user.id,
        };
        const res = await ReturnApi.postEtcReturnPrice(param);
        if (res.code === 200) {
          alert(
            "선택하신 주문에 입력된 추가 반품비용 정보가 정상적으로 등록되었습니다.",
          );
          setIsLoading(false);
          handleReturnCostSettingModalCancel();
          setSelectedRow([]);
          setSelectedRowKey([]);
          getUserOrderList();
        } else if (res.code === 406 || res.code === 999) {
          throw res.msg;
        } else {
          throw "입력하신 반품비용을 저장하는 부분에서 오류가 발생했습니다. 새로고침 후 다시 시도해주시거나 동일한 오류가 계속 발생된다면 관리자에게 문의해주시길 바랍니다.";
        }
      } catch (e) {
        setIsLoading(false);
        setError(error);
        console.log("registerEtcReturnPrice edit error", error);
        alert(e);
      }
    }
  };

  /**
   * 환불 안내 팝업 내 확인 버튼 클릭
   */
  const registerReturnComplete = async () => {
    if (
      window.confirm(
        `안내된 정보로 반품완료 및 총 ${refundInfo.total.toLocaleString()}원 환불처리 진행하시겠습니까?`,
      )
    ) {
      handleReturnComplete();
    }
  };

  /**
   * PortOne 환불 처리 + 포인트 환불 + 쿠폰 환불
   */
  const handleReturnComplete = async () => {
    setIsLoading(true);
    try {
      const selectOrder = selectedRow[0];
      const param = {
        user_id: selectOrder.created_by,
        order_id: selectOrder.order_id,
      };
      // 1. 해당 주문건 실제 결제 정보 조회
      const res = await ReturnApi.getPaymentSearchResult(param);
      if (res.code === 200) {
        let cancelParam = {
          ...res.result,
          userOrderDetailList: [...selectedRow],
          merchant_uid: selectOrder.order_id,
          reason: `[반품-${selectOrder?.cancel_reason}]${
            selectOrder.cancel_reason_detail ?? ""
          }`,
          cancel_request_amount: refundInfo.total,
          created_by: user.id === 724 ? 1 : user.id,
        };
        // 1-1. 가상계좌 결제시, 환불받을 계좌 정보 여부 확인
        if (cancelParam.pay_method === "vbank") {
          if (
            !!selectOrder.refund_bank &&
            !!selectOrder.refund_holder &&
            !!selectOrder.refund_account
          ) {
            cancelParam = {
              ...cancelParam,
              refund_holder: selectOrder.refund_holder ?? null,
              refund_bank: selectOrder.refund_bank ?? null,
              refund_account: selectOrder.refund_account ?? null,
            };
          } else {
            // setIsLoading(false);
            throw "환급 받을 계좌 정보가 없습니다.";
            // return;
          }
        }
        const pointParam = {
          totalOrder: {
            id: selectOrder.order_id,
            order_status: "return_complete",
          },
        };
        let couponList = [];
        for (let i = 0; i < selectedRow?.length; i++) {
          if (
            selectedRow[i].coupon_id &&
            selectedRow[i].coupon_id !== "ADMIN"
          ) {
            couponList.push(selectedRow[i].coupon_id);
          }
        }
        const couponParam = {
          couponIdList: couponList?.length ? couponList : [],
          user_coupon_is_available: true,
          created_by: selectOrder.created_by,
          user_id: selectOrder.created_by,
        };
        // 2. 포트원 환불
        const rsq = await ReturnApi.postReturnPortOne(cancelParam);
        if (rsq.code === 203) {
          // 2-1. 정상 환불됨 -> 포인트/쿠폰 환급
          const pointRes = await ReturnApi.postPointCancel(pointParam);
          if (pointRes.code !== 200) {
            throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
          }
          const couponRes = await promotionApi.userCouponChangeStatus(
            couponParam,
          );
          if (couponRes.code !== 200) {
            throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
          }
          setIsLoading(false);
          alert("정상적으로 환불이 완료되었습니다.");
          handleReturnCompleteModalCancel();
          setSelectedRowKey([]);
          setSelectedRow([]);
          getUserOrderList();
          getReturnSummary();
        } else if (rsq.code === 420) {
          // 2-2. 이미 환불 완료됨 -> 상태값 변경 및 포인트/쿠폰 환급
          alert("이미 환불 완료된 주문입니다. 쿠폰 및 포인트 환급 진행합니다.");
          const pointRes = await ReturnApi.postPointCancel(pointParam);
          if (pointRes.code !== 200) {
            throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
          }
          const couponRes = await promotionApi.userCouponChangeStatus(
            couponParam,
          );
          if (couponRes.code !== 200) {
            throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
          }
          changeOrderStatus("return_complete");
        } else {
          throw "오류가 발생했습니다. 관리자에게 문의하세요.";
        }
      } else {
        throw "서버오류가 발생했습니다. 새로고침 후 다시 시도해주시길 바랍니다.";
      }
    } catch (e) {
      setIsLoading(false);
      console.log("handleReturnComplete === ", e);
      alert(e);
      handleReturnCompleteModalCancel();
    }
  };

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData;
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          return {
            order_id: row.order_id,
            order_detail_id: `dy${row.order_detail_id}`,
            payment_created_at: moment(row.payment_created_at).format(
              "YYYY.MM.DD HH:mm",
            ),
            order_detail_status:
              status.matchingOrderStatus[row.order_detail_status],
            product_id: row.product_id,
            product_name: row.product_name,
            option_id: row.option_id,
            option_title: row.option_title,
            quantity: row.quantity,
            total_price: row.total_price,
            price: row.price,
            coupon_discount_price: row.coupon_discount_price,
            created_by_name: row.created_by_name,
            use_point: row.use_point ? "Y" : "N",
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.address_detail ? `, ${row.address_detail}` : "")
              : "",
            address_request:
              row.address_request === "배송 시 요청사항을 선택해주세요."
                ? ""
                : row.address_request,
            delivery_company: status.matchingDeliveryCompany[
              row.delivery_company
            ]
              ? status.matchingDeliveryCompany[row.delivery_company]
              : row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date: row.ship_date
              ? moment(row.ship_date).format("YYYY.MM.DD")
              : row.ship_date,
          };
        });
      } else if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          return {
            order_id: row.order_id,
            order_detail_id: `dy${row.order_detail_id}`,
            payment_created_at: moment(row.payment_created_at).format(
              "YYYY.MM.DD HH:mm",
            ),
            order_detail_status:
              status.matchingOrderStatus[row.order_detail_status],
            product_id: row.product_id,
            product_name: row.product_name,
            option_id: row.option_id,
            option_title: row.option_title,
            quantity: row.quantity,
            total_price: row.total_price,
            price: row.price,
            coupon_discount_price: row.coupon_discount_price,
            created_by_name: row.created_by_name,
            use_point: row.use_point ? "Y" : "N",
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.address_detail ? `, ${row.address_detail}` : "")
              : "",
            address_request:
              row.address_request === "배송 시 요청사항을 선택해주세요."
                ? ""
                : row.address_request,
            delivery_company: status.matchingDeliveryCompany[
              row.delivery_company
            ]
              ? status.matchingDeliveryCompany[row.delivery_company]
              : row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date: row.ship_date
              ? moment(row.ship_date).format("YYYY.MM.DD")
              : row.ship_date,
          };
        });
      } else {
        alert(
          "다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.",
        );
        throw "no data";
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
        ws[cellAdd].v = status.matchingKey[key];
      });
      XLSX.utils.book_append_sheet(wb, ws, "주문조회");
      XLSX.writeFile(wb, `${moment().format("YYYYMMDD")}_주문조회.xlsx`);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleExcelDownloadClick edit error", error);
    }
  };

  /**
   * 상단 반품관련 상태값 click handler
   */
  const handleReturnStatusItemClick = (returnStatus, list) => {
    setIsSearchText(returnStatus);
    if (list && list?.length > 0) {
      setDates({
        startDate: moment(list[list?.length - 1].cancel_request_date).startOf(
          "day",
        ),
        endDate: moment(list[0].cancel_request_date).endOf("day"),
      });
    } else {
      setDates({
        startDate: moment().subtract(7, "days").startOf("day"),
        endDate: moment().endOf("day"),
      });
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   * + redux에 저장된 값 지우기
   */
  const handleSearch = () => {
    setOffset(0);
    setCurrentPageNumber(1);
    setSelectedRowKey([]);
    setSelectedRow([]);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        setIsSearchText("");
        setDates({
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().add(1, "d").format("YYYY-MM-DD"),
        });
        getUserOrderList("search");
      }
    }
  };

  /**
   * 초기화
   * + redux에 저장된 값 지우기
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[1].value,
      searchOrderId: "",
      searchProductName: "",
      funnel: 0,
      name: "",
      phone: "",
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    setPageSize(10);
    setSelectedRowKey([]);
    setSelectedRow([]);
    setIsSearchText("");
    setDates({
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().add(1, "d").format("YYYY-MM-DD"),
    });
    getUserOrderList("initial");
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("return_request_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  /**
   * 송장번호에 따른 배송안내 popup
   * @param detail
   */
  const deliveryPopup = (e, detail) => {
    e.preventDefault();
    e.stopPropagation();
    let popUrl = `https://${
      detail.return_goodsflow_service_id
        ? `www.goodsflow.io/tracking/tXYtiyVnAX/${detail.return_goodsflow_service_id}`
        : `tracker.delivery/#/${detail.return_delivery_company}/${detail.return_tracking_number}`
    }`;
    let popOption =
      "top=10, left=10, width=500, height=700, scrollbars=yes, resizable=no";
    window.open(popUrl, "배송조회", popOption);
  };

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false);
    setOrderDetail({});
  };

  /**
   * 반품 승인처리 Modal click handler
   */
  const handleReceiveModalClick = () => {
    setReceiveModalOpen(true);
    for (let i = 0; i < selectedRow?.length; i++) {
      const row = selectedRow[i];
      if (row.shipment_place) {
        setTrackNumber({
          ...trackNumber,
          shipment_place: row.shipment_place,
        });
        break;
      }
    }
  };

  /**
   * 반품 승인처리 Modal cancel handler
   */
  const handleReceiveModalCancel = () => {
    setReceiveModalOpen(false);
    setTrackNumber({
      delivery_company: null,
      tracking_number: "",
      shipment_place: "",
      collection_date:
        moment().add(3, "days").day() === 0
          ? moment().add(4, "days")
          : moment().add(3, "days"),
    });
  };

  /**
   * 반품 승인처리 Modal > 선택된 주문 정보 테이블 row click
   */
  const handleSelectedOrderRowEvent = (record, _) => {
    return {
      onClick: (_) => {
        setTrackNumber({
          ...trackNumber,
          shipment_place: record.shipment_place,
        });
        setIsEditForShipmentPlace(false);
      },
    };
  };

  /**
   * 반품 거부(철회) 처리 Modal cancel handler
   */
  const handleReturnRefusalModalCancel = () => {
    setReturnRefusalModalOpen(false);
    setRefusalReason(null);
  };

  /**
   * 반품 송장 입력 Modal click handler
   */
  const handleRegisterTrackingClick = () => {
    setIsTrackNumberShow(true);
    for (let i = 0; i < selectedRow?.length; i++) {
      const row = selectedRow[i];
      if (row.return_tracking_number && !trackNumber.tracking_number) {
        setTrackNumber({
          tracking_number: row.return_tracking_number,
          delivery_company: row.return_delivery_company,
        });
        break;
      }
    }
  };

  /**
   * 반품 송장 입력 Modal cancel handler
   */
  const handleRegisterTrackingModalCancel = () => {
    setIsTrackNumberShow(false);
    setTrackNumber({
      delivery_company: null,
      tracking_number: "",
    });
  };

  /**
   * 반품비용 설정 Modal click handler
   */
  const handleReturnCostSettingClick = async () => {
    await getOrderDetailListInfoForReturn();
    setCostSettingModalOpen(true);
  };

  /**
   * 반품비용 설정 Modal cancel handler
   */
  const handleReturnCostSettingModalCancel = () => {
    setCostSettingModalOpen(false);
    setCostInfo({
      possible_amount: 0,
      additional_cost: 0,
      reason: null,
    });
  };

  /**
   * 반품완료 > 환불안내 Modal cancel handler
   */
  const handleReturnCompleteModalCancel = () => {
    setReturnCompleteModalOpen(false);
    setRefundInfo({
      cal_history: "",
      total: 0,
    });
  };

  /**
   * 반품 승인처리 버튼 밸리데이션 - 반품요청, 반품거부
   * @returns {boolean}
   */
  const disabledReturnRequest = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      return !selectedRow.every(
        (row) => row.order_detail_status === "return_request",
      );
    }
  };

  /**
   * 반품 거부처리 버튼 밸리데이션 - 반품 완료 처리가 불가능한 건 (반품 불가상품 또는 파손된 경우)
   * + 동일한 주문번호만 선택할 수 있도록 처리 (반품완료/반품거부(철회) 제외) (2023.07.11) - ksb
   * @returns {boolean}
   */
  const disabledReturnRefusal = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      let orderId = 0;
      let validList = [];
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i];
        if (i === 0) {
          orderId = row.order_id;
          if (
            row.order_detail_status === "return_complete" ||
            row.order_detail_status === "return_refusal"
          ) {
            validList.push(false);
          } else {
            validList.push(true);
          }
        } else {
          if (row.order_id !== orderId) {
            validList.push(false);
          } else {
            if (
              row.order_detail_status === "return_complete" ||
              row.order_detail_status === "return_refusal"
            ) {
              validList.push(false);
            } else {
              validList.push(true);
            }
          }
        }
      }
      return !validList.every((result) => result);
    }
  };

  /**
   * 반품 송장 입력 버튼 밸리데이션 - 반품승인/반품수거완료/반품수거취소/반품배송중 및 동일한 주문번호만 허용
   * @returns {boolean}
   */
  const disabledReturnReceive = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      let orderId = 0;
      let validList = [];
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i];
        if (i === 0) {
          orderId = row.order_id;
          if (
            row.order_detail_status === "return_receive" ||
            row.order_detail_status === "return_collection_complete" ||
            row.order_detail_status === "return_delivery" ||
            row.order_detail_status === "return_collection_fail"
          ) {
            validList.push(true);
          } else {
            validList.push(false);
          }
        } else {
          if (row.order_id !== orderId) {
            validList.push(false);
          } else {
            if (
              row.order_detail_status === "return_receive" ||
              row.order_detail_status === "return_collection_complete" ||
              row.order_detail_status === "return_delivery" ||
              row.order_detail_status === "return_collection_fail"
            ) {
              validList.push(true);
            } else {
              validList.push(false);
            }
          }
        }
      }
      return !validList.every((result) => result);
    }
  };

  /**
   * 반품 입고 완료 버튼 밸리데이션 - 반품승인/반품수거완료/반품수거취소/반품배송중만 허용
   * @returns {boolean}
   */
  const disabledReturnCollection = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      return !selectedRow.every(
        (row) =>
          row.order_detail_status === "return_receive" ||
          row.order_detail_status === "return_collection_complete" ||
          row.order_detail_status === "return_collection_fail" ||
          row.order_detail_status === "return_delivery",
      );
    }
  };

  /**
   * 반품 완료처리 버튼 밸리데이션 - 동일한 주문번호에 대해 반품배송완료만 허용
   * @returns {boolean}
   */
  const disabledReturnComplete = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      let orderId = 0;
      let validList = [];
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i];
        if (i === 0) {
          orderId = row.order_id;
          if (row.order_detail_status === "return_delivery_complete") {
            validList.push(true);
          } else {
            validList.push(false);
          }
        } else {
          if (
            row.order_id === orderId &&
            row.order_detail_status === "return_delivery_complete"
          ) {
            validList.push(true);
          } else {
            validList.push(false);
          }
        }
      }
      return !validList.every((result) => result);
    }
  };

  /**
   * 반품 비용 설정 버튼 밸리데이션 - 반품배송완료인 하나의 주문만 허용
   * @returns {boolean}
   */
  const disabledReturnCostSetting = () => {
    return !(
      selectedRow?.length === 1 &&
      selectedRow[0].order_detail_status === "return_delivery_complete"
    );
  };

  return (
    <>
      <ContentHeaderComponent title="반품관리" />
      <div className="product-register-wrap">
        {/* 반품 상태값 조회 */}
        <Row
          justify="space-around"
          className="product-search-product-status-wrap return-wrap"
        >
          {/* 수거요청실패 부터 4개 */}
          <div className={`product-return-wrap`}>
            <Row
              className={`product-status-box-wrap ${
                searchText && searchText === "return_collection_fail"
                  ? "product-status-active"
                  : ""
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  "return_collection_fail",
                  returnStatus.returnCollectionFail,
                )
              }
              onMouseEnter={() => setCollectionFailHover(true)}
              onMouseLeave={() => setCollectionFailHover(false)}
            >
              <img
                className="product-status-icon"
                src={`${
                  process.env.REACT_APP_HOST
                }/assets/images/product/return${
                  (searchText && searchText === "return_collection_fail") ||
                  collectionFailHover
                    ? "B"
                    : ""
                }-4.png`}
                alt={`수거요청실패`}
              />
              <div className="product-status-text">
                <div>수거요청실패</div>
                <div>
                  <span
                    className="product-status-num"
                    style={{ color: "#fe2b4b", fontWeight: "bold" }}
                  >
                    {returnStatus.returnCollectionFail
                      ? returnStatus.returnCollectionFail?.length
                      : 0}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
            <Row
              className={`product-status-box-wrap ${
                searchText && searchText === "return_delay"
                  ? "product-status-active"
                  : ""
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  "return_delay",
                  returnStatus.returnDelay,
                )
              }
              onMouseEnter={() => setReturnDelayHover(true)}
              onMouseLeave={() => setReturnDelayHover(false)}
            >
              <img
                className="product-status-icon"
                src={`${
                  process.env.REACT_APP_HOST
                }/assets/images/product/return${
                  (searchText && searchText === "return_delay") ||
                  returnDelayHover
                    ? "B"
                    : ""
                }-5.png`}
                alt={`반품지연`}
              />
              <div className="product-status-text">
                <div>반품지연</div>
                <div>
                  <span
                    className="product-status-num"
                    style={{ color: "#fe2b4b", fontWeight: "bold" }}
                  >
                    {returnStatus.returnDelay
                      ? returnStatus.returnDelay?.length
                      : 0}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>

            <Row
              className={`product-status-box-wrap ${
                searchText && searchText === "return_refund_delay"
                  ? "product-status-active"
                  : ""
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  "return_refund_delay",
                  returnStatus.returnRefundDelay,
                )
              }
              onMouseEnter={() => setRefundDelayHover(true)}
              onMouseLeave={() => setRefundDelayHover(false)}
            >
              <img
                className="product-status-icon"
                src={`${
                  process.env.REACT_APP_HOST
                }/assets/images/product/return${
                  (searchText && searchText === "return_refund_delay") ||
                  refundDelayHover
                    ? "B"
                    : ""
                }-6.png`}
                alt={`환불지연`}
              />
              <div className="product-status-text">
                <div>환불지연</div>
                <div>
                  <span
                    className="product-status-num"
                    style={{ color: "#fe2b4b", fontWeight: "bold" }}
                  >
                    {returnStatus.returnRefundDelay
                      ? returnStatus.returnRefundDelay?.length
                      : 0}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>

            {/*빈 공간을 위한 상태 아이템*/}
            <Row
              className="product-status-box-wrap"
              style={{
                visibility: "hidden",
                width: "25%",
              }}
            >
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/product/return-6.png`}
                alt={`환불지연`}
              />
              <div className="product-status-text">
                <div>환불지연</div>
                <div>
                  <span
                    className="product-status-num"
                    style={{ color: "#fe2b4b", fontWeight: "bold" }}
                  >
                    {returnStatus.returnRefundDelay
                      ? returnStatus.returnRefundDelay?.length
                      : 0}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </div>
          {/*반품요청 부터 4개*/}
          <div className={`product-return-wrap`}>
            {/* 반품 요청 부터 4개 표기 */}
            <Row
              className={`product-status-box-wrap ${
                searchText && searchText === "return_request"
                  ? "product-status-active"
                  : ""
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  "return_request",
                  returnStatus.returnRequest,
                )
              }
              onMouseEnter={() => setReturnRequestHover(true)}
              onMouseLeave={() => setReturnRequestHover(false)}
            >
              <img
                className="product-status-icon"
                src={`${
                  process.env.REACT_APP_HOST
                }/assets/images/product/return${
                  (searchText && searchText === "return_request") ||
                  returnRequestHover
                    ? "B"
                    : ""
                }-0.png`}
                alt={`반품요청`}
              />
              <div className="product-status-text">
                <div>반품요청</div>
                <div>
                  <span className="product-status-num">
                    {returnStatus.returnRequest
                      ? returnStatus.returnRequest?.length
                      : 0}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>

            <Row
              className={`product-status-box-wrap ${
                searchText && searchText === "return_delivery"
                  ? "product-status-active"
                  : ""
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  "return_delivery",
                  returnStatus.returnDelivery,
                )
              }
              onMouseEnter={() => setReturnDeliveryHover(true)}
              onMouseLeave={() => setReturnDeliveryHover(false)}
            >
              <img
                className="product-status-icon"
                src={`${
                  process.env.REACT_APP_HOST
                }/assets/images/product/return${
                  (searchText && searchText === "return_delivery") ||
                  returnDeliveryHover
                    ? "B"
                    : ""
                }-1.png`}
                alt={`반품배송중`}
              />
              <div className="product-status-text">
                <div>반품배송중</div>
                <div>
                  <span className="product-status-num">
                    {returnStatus.returnDelivery
                      ? returnStatus.returnDelivery?.length
                      : 0}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>

            <Row
              className={`product-status-box-wrap ${
                searchText && searchText === "return_delivery_complete"
                  ? "product-status-active"
                  : ""
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  "return_delivery_complete",
                  returnStatus.returnDeliveryComplete,
                )
              }
              onMouseEnter={() => setReturnDeliveryCompleteHover(true)}
              onMouseLeave={() => setReturnDeliveryCompleteHover(false)}
            >
              <img
                className="product-status-icon"
                src={`${
                  process.env.REACT_APP_HOST
                }/assets/images/product/return${
                  (searchText && searchText === "return_delivery_complete") ||
                  returnDeliveryCompleteHover
                    ? "B"
                    : ""
                }-2.png`}
                alt={`반품배송완료`}
              />
              <div className="product-status-text">
                <div>반품배송완료</div>
                <div>
                  <span className="product-status-num">
                    {returnStatus.returnDeliveryComplete
                      ? returnStatus.returnDeliveryComplete?.length
                      : 0}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>

            <Row
              className={`product-status-box-wrap ${
                searchText && searchText === "return_complete"
                  ? "product-status-active"
                  : ""
              }`}
              onClick={() =>
                handleReturnStatusItemClick(
                  "return_complete",
                  returnStatus.returnComplete,
                )
              }
              onMouseEnter={() => setReturnCompleteHover(true)}
              onMouseLeave={() => setReturnCompleteHover(false)}
            >
              <img
                className="product-status-icon"
                src={`${
                  process.env.REACT_APP_HOST
                }/assets/images/product/return${
                  (searchText && searchText === "return_complete") ||
                  returnCompleteHover
                    ? "B"
                    : ""
                }-3.png`}
                alt={"반품완료(최근 3일)"}
              />
              <div className="product-status-text">
                <div>반품완료(최근 3일)</div>
                <div>
                  <span className="product-status-num">
                    {returnStatus.returnComplete
                      ? returnStatus.returnComplete?.length
                      : 0}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </div>
        </Row>

        {/*주문검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {searchDateItems.map((item, idx) => (
                <Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Option>
              ))}
            </Select>
            <Row align={"middle"} style={{ marginTop: 10, gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="처리상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {orderStatusItems.map((item, idx) => (
                <Option key={`order_status_search_${idx}`} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          {/*<Form.Item*/}
          {/*    className="center-label"*/}
          {/*    label="유입경로"*/}
          {/*    labelAlign="left"*/}
          {/*    colon={false}*/}
          {/*    labelCol={{span: 3}}*/}
          {/*    wrapperCol={{span: 21}}*/}
          {/*>*/}
          {/*    <Radio.Group options={funnelStatusItems} onChange={(e) => setSearchOptions({ ...searchOptions, funnel: e.target.value })} value={searchOptions.funnel} />*/}
          {/*</Form.Item>*/}
          {/*<Divider className="product-register-form-input-divider"/>*/}
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className="content-search-wrap">주문번호</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    const reg = /^[0-9]*$/;
                    if (reg.test(e.target.value) || e.target.value === "") {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      });
                    }
                  }}
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">상품명</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">이름</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문검색목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className="product-register-box-title">
              상품목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
          <div>
            <Button
              className="order-excel-download-btn"
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
        >
          <div>
            <Button
              className="order-status-change-button"
              disabled={disabledReturnRequest()}
              loading={isLoading}
              onClick={handleReceiveModalClick}
            >
              반품 승인처리
            </Button>
            <Button
              className="order-status-change-button"
              disabled={disabledReturnRefusal()}
              onClick={() => setReturnRefusalModalOpen(true)}
              // loading={isLoading}
              // onClick={() => changeOrderStatus("return_refusal")}
            >
              반품 거부처리
            </Button>
            {/*<Button className="order-status-change-button" disabled={disabledReturnRequest()}
                                    loading={isLoading}*/}
            {/*        onClick={() => changeOrderStatus("delivery_ready")}>*/}
            {/*    반품 완료처리*/}
            {/*</Button>*/}
            {/*<Button className="order-status-change-button"
                                    loading={isLoading}*/}
            {/*        onClick={() => setIsDeliveryShippingModalOpen(true)}>엑셀 일괄 발송처리</Button>*/}
            {/*<Button className="order-status-change-button" disabled={disabledAdminCancelComplete()}
                                    loading={isLoading}*/}
            {/*        onClick={() => orderDirectlyCancel()}>*/}
            {/*    교환으로 변경*/}
            {/*</Button>*/}
          </div>
          <div>
            <Button
              className="order-status-change-button"
              disabled={disabledReturnReceive()}
              loading={isLoading}
              onClick={handleRegisterTrackingClick}
            >
              반품 송장 입력
            </Button>
          </div>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="order_detail_id"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: "max-content" }}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
        <div
          className="product-register-border-box"
          style={{
            backgroundColor: "#f8f9fd",
            height: "fit-content",
            padding: "15px 25px",
            borderTop: 0,
          }}
        >
          <Form.Item
            className="order-bottom-form-item center-label"
            label="반품처리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className="order-status-change-button"
                disabled={disabledReturnCollection()}
                loading={isLoading}
                onClick={() => changeOrderStatus("return_delivery_complete")}
              >
                입고 완료
              </Button>
              <Button
                className="order-status-change-button"
                disabled={disabledReturnComplete()}
                loading={isLoading}
                onClick={handleReturnCompleteClick}
              >
                반품 완료처리
              </Button>
              {/*<Button className="order-status-change-button"
                                    loading={isLoading}
                                    disabled={disabledReturnRequest()}*/}
              {/*        onClick={() => changeOrderStatus("delivery_ready")}>*/}
              {/*    교환으로 변경*/}
              {/*</Button>*/}
            </Row>
          </Form.Item>
          {user &&
            ((user.role && user.role === "super_admin") || user.id === 2) && (
              <>
                <Divider className="product-register-form-input-divider order-bottom-divider-margin" />
                <Form.Item
                  className="order-bottom-form-item center-label"
                  label="환불처리"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Row>
                    <Button
                      className="order-status-change-button"
                      disabled={disabledReturnCostSetting()}
                      loading={isLoading}
                      onClick={handleReturnCostSettingClick}
                    >
                      반품비용 설정
                    </Button>
                  </Row>
                </Form.Item>
              </>
            )}
          {/*<Form.Item*/}
          {/*    className="order-bottom-form-item center-label"*/}
          {/*    label="정보 수정"*/}
          {/*    labelAlign="left"*/}
          {/*    colon={false}*/}
          {/*    labelCol={{span: 3}}*/}
          {/*    wrapperCol={{span: 21}}*/}
          {/*>*/}
          {/*    <Row>*/}
          {/*        <Button className="order-status-change-button" disabled={true}>*/}
          {/*                /!*onClick={() => changeOrderStatus("delivery_ready")}*!/*/}
          {/*            변경사유 수정*/}
          {/*        </Button>*/}
          {/*        <Button className="order-status-change-button" disabled={true}>*/}
          {/*                /!*onClick={() => changeOrderStatus("delivery_ready")}*!/*/}
          {/*            수거정보 수정*/}
          {/*        </Button>*/}
          {/*    </Row>*/}
          {/*    /!*<div style={{marginTop: 10}}>* 배송사 및 송장번호 입력 후, 발송처리를 눌러주세요.</div>*!/*/}
          {/*</Form.Item>*/}
          {/*<Divider className="product-register-form-input-divider order-bottom-divider-margin"/>*/}
          {/*<Form.Item*/}
          {/*    className="order-bottom-form-item"*/}
          {/*    label="반품교환관리"*/}
          {/*    labelAlign="left"*/}
          {/*    colon={false}*/}
          {/*    labelCol={{span: 3}}*/}
          {/*    wrapperCol={{span: 21}}*/}
          {/*>*/}
          {/*    <Row>*/}
          {/*        <Button className="order-status-change-button" disabled={disabledAdminCancelComplete()}*/}
          {/*                onClick={() => orderDirectlyCancel()}>판매자 직접취소 처리</Button>*/}
          {/*        <Button className="order-status-change-button" disabled={disabledReturnCollection()}*/}
          {/*                onClick={() => handleCancelComplete()}>취소 승인처리</Button>*/}
          {/*    </Row>*/}
          {/*    <div style={{marginTop: 10}}>* 같은 주문번호에 한해서만 다건처리가 가능합니다. 혹은 하나씩 선택해주세요.</div>*/}
          {/*</Form.Item>*/}
        </div>

        {/*반품 승인시 회수택배사/수거예정일/수거지 입력*/}
        <Modal
          title="반품 승인 처리"
          visible={receiveModalOpen}
          onCancel={handleReceiveModalCancel}
          onOk={returnReceive}
          okText={<span>저장</span>}
          okButtonProps={{
            disabled: !(
              trackNumber.delivery_company &&
              trackNumber.collection_date &&
              trackNumber.shipment_place?.trim()
            ),
          }}
          centered={true}
          confirmLoading={isLoading}
          width={"50%"}
        >
          <p style={{ marginBottom: 0 }}>
            • 구매자분께 안내드릴 수거 택배사 및 수거 예정일을 입력해주세요.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 수거지는 각 상품별 판매자정보에 등록된 반품/교환 회수지입니다.
            직접 수정하시면 선택된 주문 목록 전체에 적용됩니다.
          </p>
          <Row className="select-order-info-title">
            <div className="deco-box"></div>
            선택된 주문 정보
          </Row>
          <Table
            columns={columnsForRefusal}
            dataSource={selectedRow}
            // loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="order_detail_id"
            rowClassName="coupon-table-row"
            onRow={handleSelectedOrderRowEvent}
            scroll={{ x: "max-content", y: 145 }}
            pagination={false}
          />
          <Form.Item
            className="register-tracking-number-form"
            label="택배사"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Select
              placeholder="택배사를 선택헤주세요"
              value={trackNumber.delivery_company}
              onChange={(value) =>
                setTrackNumber({
                  ...trackNumber,
                  delivery_company: value,
                })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {deliveryCompanyList.map((item, idx) => (
                <Option
                  key={`delivery_company_${idx}`}
                  value={item.delivery_company_id}
                >
                  {item.delivery_company_name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            className="register-tracking-number-form"
            label="수거 예정일"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <DatePicker
              className="order-search-date-wrap"
              format="YYYY/MM/DD"
              allowClear={false}
              disabledDate={(current) =>
                current < moment().endOf("day") || current.day() === 0
              }
              value={trackNumber.collection_date}
              onChange={(value) => {
                setTrackNumber({ ...trackNumber, collection_date: value });
              }}
            />
          </Form.Item>
          <Form.Item
            className="register-tracking-number-form"
            label="수거지"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input
              value={trackNumber.shipment_place}
              onChange={(e) => {
                setIsEditForShipmentPlace(true);
                setTrackNumber({
                  ...trackNumber,
                  shipment_place: e.target.value,
                });
              }}
            />
          </Form.Item>
        </Modal>

        {/*반품 거부 사유 입력*/}
        <Modal
          title="반품 거부(철회) 처리"
          visible={returnRefusalModalOpen}
          onCancel={handleReturnRefusalModalCancel}
          onOk={returnRefusal}
          okText={<span>저장</span>}
          okButtonProps={{ disabled: !refusalReason?.trim() }}
          centered={true}
          confirmLoading={isLoading}
          width={"50%"}
        >
          <p style={{ marginBottom: 0 }}>
            • 구매자에게 반품불가 사유를 사전에 안내하시고 반품 거부처리 진행해
            주세요.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 입력하신 반품거부 사유는 구매자에게 안내됩니다.
          </p>
          <Row className="select-order-info-title">
            <div className="deco-box"></div>
            선택된 주문 정보
          </Row>
          <Table
            // rowSelection={rowSelection}
            columns={columnsForRefusal}
            dataSource={selectedRow}
            // loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="order_detail_id"
            // rowClassName="coupon-table-row"
            scroll={{ x: "max-content", y: 145 }}
            pagination={false}
          />
          <Form.Item
            className="refusal-text-form"
            label="반품 거부 사유"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            required
          >
            <Input.TextArea
              name="refusal_reason"
              value={refusalReason}
              onChange={(e) => setRefusalReason(e.target.value)}
            />
          </Form.Item>
        </Modal>

        {/* 반품 송장 입력 */}
        <Modal
          title="반품 송장 입력"
          visible={isTrackNumberShow}
          onCancel={handleRegisterTrackingModalCancel}
          onOk={handleTrackNumber}
          okText={<span>저장</span>}
          okButtonProps={{
            disabled: !(
              trackNumber.tracking_number?.trim() &&
              trackNumber.delivery_company
            ),
          }}
          confirmLoading={isLoading}
          centered={true}
          width={"50%"}
        >
          <Row className="select-order-info-title" style={{ marginTop: 0 }}>
            <div className="deco-box"></div>
            선택된 주문 정보
          </Row>
          <Table
            // rowSelection={rowSelection}
            columns={columnsForRefusal}
            dataSource={selectedRow}
            // loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="order_detail_id"
            // rowClassName="coupon-table-row"
            scroll={{ x: "max-content", y: 145 }}
            pagination={false}
          />
          <Form.Item
            className="register-tracking-number-form"
            label="택배사"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Select
              placeholder="택배사를 선택해주세요"
              value={trackNumber.delivery_company}
              onChange={(value) =>
                setTrackNumber({
                  ...trackNumber,
                  delivery_company: value,
                })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {deliveryCompanyList.map((item, idx) => (
                <Option
                  key={`delivery_company_${idx}`}
                  value={item.delivery_company_id}
                >
                  {item.delivery_company_name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="송장번호"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input
              className="order-modal-address-request-wrap"
              name="track_number"
              value={trackNumber.tracking_number}
              onChange={(e) =>
                setTrackNumber({
                  ...trackNumber,
                  tracking_number: e.target.value,
                })
              }
            />
          </Form.Item>
        </Modal>

        {/*반품비용 설정*/}
        <Modal
          title="반품비용 설정"
          visible={costSettingModalOpen}
          onCancel={handleReturnCostSettingModalCancel}
          onOk={registerEtcReturnPrice}
          okText={<span>저장</span>}
          okButtonProps={{
            disabled: !(
              costInfo.reason?.trim() && costInfo.additional_cost !== null
            ),
          }}
          confirmLoading={isLoading}
          centered={true}
          width={"50%"}
        >
          <p style={{ marginBottom: 0 }}>
            • 상품 파손 등의 이유로 반품배송비 이외의 금액을 제외하고 환불해야할
            경우에 작성해주세요.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 선택된 주문번호로 결제된 금액 및 상품별 설정된 반품비용을 제외한
            금액 내에서 설정가능합니다.
          </p>
          <p style={{ marginBottom: 0 }}>
            • 작성된 사유로 고객분께 안내가 될 예정이니 신중하게 작성해주시길
            바랍니다.
          </p>
          <Row className="select-order-info-title">
            <div className="deco-box"></div>
            선택된 주문 정보
          </Row>
          <Table
            // rowSelection={rowSelection}
            columns={columnsForRefusal}
            dataSource={selectedRow}
            // loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="order_detail_id"
            // rowClassName="coupon-table-row"
            scroll={{ x: "max-content", y: 145 }}
            pagination={false}
          />
          <Form.Item
            className="return-additional-cost-input-form refusal-text-form"
            label="추가 반품비용 금액"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Row align="middle">
              <InputNumber
                formatter={(value) =>
                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                min={0}
                max={costInfo.possible_amount}
                addonAfter="원"
                disabled={!costInfo?.possible_amount}
                value={costInfo.additional_cost}
                onChange={(value) =>
                  setCostInfo({ ...costInfo, additional_cost: value })
                }
              />
              <p
                style={{
                  marginLeft: "1rem",
                  marginBottom: 0,
                  color: "#fe2b4b",
                }}
              >
                *{" "}
                {costInfo.possible_amount
                  ? costInfo.possible_amount.toLocaleString() + "원 이하"
                  : "입력할 수 없음"}
              </p>
            </Row>
          </Form.Item>
          <Form.Item
            className="refusal-text-form"
            label="사유"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input.TextArea
              name="reason"
              value={costInfo.reason}
              onChange={(e) =>
                setCostInfo({ ...costInfo, reason: e.target.value })
              }
            />
          </Form.Item>
        </Modal>

        {/*환불 안내*/}
        {returnCompleteModalOpen && (
          <Modal
            title="환불 안내"
            wrapClassName="return-complete-modal-wrap"
            visible={returnCompleteModalOpen}
            closable={false}
            onCancel={handleReturnCompleteModalCancel}
            onOk={registerReturnComplete}
            okText={<span>확인</span>}
            confirmLoading={isLoading}
            centered={true}
            width={"50%"}
          >
            <Form.Item
              className="return-complete-form-border-box"
              label="주문번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {selectedRow[0].order_id}
            </Form.Item>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="return-complete-form-border-box"
                  label="수취인명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {selectedRow[0].name}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="return-complete-form-border-box"
                  label="구매자명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {selectedRow[0].created_by_name
                    ? selectedRow[0].created_by_name
                    : selectedRow[0].name}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              className="return-complete-form-border-box"
              label="상품명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {`[${selectedRow[0].product_brand_name}] ${
                selectedRow[0].product_name
              }${
                selectedRow[0].option_id
                  ? ` - ${selectedRow[0].option_title}`
                  : ""
              }${
                selectedRow?.length > 1
                  ? ` 외 ${selectedRow?.length - 1}건`
                  : ""
              }`}
            </Form.Item>
            <Form.Item
              className="return-complete-form-border-box"
              label="결제금액"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {`${selectedRow[0].payment_total_price.toLocaleString()}원`}
            </Form.Item>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="return-complete-form-border-box"
                  label="반품 배송비"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {selectedRow[0].return_responsibility === 0
                    ? `${(
                        selectedRow[0].return_delivery_price -
                        selectedRow[0].paid_total_delivery_price
                      )?.toLocaleString()}원`
                    : "0원"}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="return-complete-form-border-box"
                  label="결제정보"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {selectedRow[0].return_responsibility === 0
                    ? selectedRow[0].purchase_return_price
                      ? "선불"
                      : "환불금에서 차감"
                    : "판매자 부담"}
                </Form.Item>
              </Col>
            </Row>
            {selectedRow.map((row) => {
              if (row.etc_return_price) {
                return (
                  <>
                    <Form.Item
                      className="return-complete-form-border-box"
                      label="추가 반품비"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                    >
                      {`${row.etc_return_price.toLocaleString()}원`}
                    </Form.Item>
                    <Form.Item
                      className="return-complete-form-border-box"
                      label="사유"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                    >
                      {row.etc_return_price_reason}
                    </Form.Item>
                  </>
                );
              }
            })}
            <Form.Item
              className="return-complete-form-border-box"
              label="총 환불 금액"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              style={{ borderBottom: "solid 1px #ced4da" }}
            >
              <p style={{ marginBottom: 0 }}>{refundInfo.cal_history}</p>
              <p className="return-complete-refund-amount">{`${refundInfo.total.toLocaleString()}원`}</p>
            </Form.Item>
          </Modal>
        )}

        {/*주문 상세 페이지*/}
        {isOrderModalOpen && (
          <Modal
            title="상품주문정보 조회"
            wrapClassName="order-detail-modal-wrap"
            visible={isOrderModalOpen}
            centered={true}
            onCancel={handleOrderDetailModalCancel}
            footer={null}
            width="70%"
          >
            <OrderDetailComponent
              orderDetail={orderDetail}
              handleOrderDetailModalCancel={handleOrderDetailModalCancel}
              getUserOrderList={getUserOrderList}
            />
          </Modal>
        )}
      </div>
    </>
  );
};

export default ReturnManage;
